'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LoadingOverlayService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('./module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LoadingOverlayService = exports.LoadingOverlayService = function () {
    function LoadingOverlayService($rootScope) {
        _classCallCheck(this, LoadingOverlayService);

        this.count = 0;
        this.isLoading = false;
        this.webComponent = false;
        this.$rootScope = $rootScope;
    }

    _createClass(LoadingOverlayService, [{
        key: 'start',
        value: function start() {
            this.count++;
            if (this.count == 1) {
                this.isLoading = true;
                this.$rootScope.$broadcast('resizeOverlay');
            }
        }
    }, {
        key: 'stop',
        value: function stop() {
            this.count--;
            if (this.count < 0) {
                this.count = 0;
            }
            if (this.count == 0) {
                this.isLoading = false;
            }
        }
    }]);

    return LoadingOverlayService;
}();

LoadingOverlayService.$inject = ['$rootScope'];

_module3.default.service('loadingOverlayService', LoadingOverlayService);


//////////////////
// WEBPACK FOOTER
// ./src/core/loadingOverlayService.js
// module id = 70
// module chunks = 0 2